import PortfolioInvestmentsError from './PortfolioInvestmentsError';
class InvalidFormatEntry extends PortfolioInvestmentsError {
    constructor(options) {
        super('The request input does not meet the required format', options);
    }
}
export default InvalidFormatEntry;
